<template>
  <modal name="share-modal" transition="pop-out" :width="modalWidth" height="auto" :adaptive="true" @before-open="beforeOpen">
    <div class="flex flex-column items-center mb3">
      <div class="flex justify-end w-100">
        <a @click="closeModal" class="pointer pa3 textColor">
          <font-awesome-icon icon="times" size="2x" />
        </a>
      </div>
      <div class="flex justify-center fl w-30 pb2">
        <img class="h-100 w-100" src="../../assets/logo-white.svg" alt="BeatHey Logo">
      </div>
      <div v-if="track !== null">
        <h3 class="mv1 tc textColor" v-show="track">{{ $t("tracks.shareTrack.title") }}</h3>
        <div class="flex justify-center ma3-ns ma1 w-100">
          <track-info v-show="track" :track="track" :inModal="true" class="flex justify-center textColor"></track-info>
        </div>
      </div>
      <div v-if="playlist !== null">
        <h3 class="mv1 tc textColor">{{ $t("playlists.sharePlaylist") }}</h3>
        <div class="flex justify-center ma3-ns ma1 w-100">
          <playlist-info v-show="playlist" :playlist="playlist" class="flex justify-center textColor"></playlist-info>
        </div>
      </div>
      <social-sharing class="flex w-100 justify-center"
        :url="link"
        :title="title"
        :description="description"
        hashtags="BeatHey"
        inline-template>
        <div>
          <network class="pointer pa3 textColor" network="facebook">
            <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"/>
          </network>
          <network class="pointer pa3 textColor" network="twitter">
            <font-awesome-icon :icon="['fab', 'twitter-square']" size="2x"/>
          </network>
          <network class="pointer pa3 textColor dn-ns db" network="whatsapp">
            <font-awesome-icon :icon="['fab', 'whatsapp']" size="2x"/>
          </network>
        </div>
      </social-sharing>
      <div class="flex flex-column items-center mh2 w-100">
        <input contenteditable="true" readonly class="w-two-thirds block ma2 ph1 pv2 input bg-white h2" v-model="link"/>
        <button class="btn w-third pointer" v-clipboard="link"
          @success="clipboardSuccess"
          @error="clipboardError"> {{ $t("tracks.shareTrack.copy") }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import TrackInfo from '@/components/tracks/TrackInfo.vue'
import PlaylistInfo from '@/components/playlists/PlaylistInfo.vue'

const MODAL_WIDTH = 600
export default {
  name: 'share-modal',
  components: {
    FontAwesomeIcon,
    TrackInfo,
    PlaylistInfo
  },
  data () {
    return {
      modalWidth: MODAL_WIDTH,
      color: '#808080',
      size: '50px',
      link: '',
      title: '',
      description: '',
      track: null,
      playlist: null
    }
  },
  created () {
    this.modalWidth = window.innerWidth < MODAL_WIDTH
      ? MODAL_WIDTH / 2
      : MODAL_WIDTH
  },
  methods: {
    closeModal () {
      this.track = Object
      this.artist = Object
      this.$modal.hide('share-modal')
    },
    beforeOpen (event) {
      this.track = null
      this.playlist = null
      this.link = event.params.link
      this.title = event.params.title
      this.decription = event.params.description
      if (event.params.track) {
        this.track = event.params.track
      } else if (event.params.playlist) {
        this.playlist = event.params.playlist
      }
    },
    clipboardSuccess () {
      this.$toasted.show(this.$t('tracks.shareTrack.success'), {type: 'success'})
    },
    clipboardError () {
      this.$toasted.show(this.$t('tracks.shareTrack.error'), {type: 'error'})
    }
  }
}
</script>

<style scoped>
  .input {
    border: 1px solid #DDDEDF;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/ShareModal.vue